import React, { useMemo } from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import MultiSelect, {
  MultiOption,
  MultiOptionValue,
  MultiSelectProps,
} from 'components/MultiSelect/MultiSelect.component';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './MultiSelectField.styles.scss';

type MultiSelectFieldProps = FieldWrapperProps &
  MultiSelectProps<MultiOptionValue> &
  FieldRenderProps<Array<MultiOption<MultiOptionValue>>, HTMLElement>;

const MultiSelectField: React.FC<MultiSelectFieldProps> = (props) => {
  const {
    className,
    label,
    input,
    meta: { touched, error },
    ...rest
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames(
    'multi-select-field',
    { 'multi-select-field--error': hasError },
    className,
  );

  return (
    <FieldWrapper
      className={classes}
      hasError={hasError}
      error={error}
      {...rest}
    >
      <MultiSelect
        className={classes}
        {...rest}
        {...input}
        hasError={hasError}
      />
    </FieldWrapper>
  );
};

export default MultiSelectField;
